import React, { useContext, useEffect, useState } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import { FullGridContext } from "..";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import ModalFilters, { getStoredFilters } from "./ModalFilters";
import { Pin } from "lucide-react";
import api from "~/services/api";

export default function AdministrativeStudent() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "name", asc: true };
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);
  const [applyingFilters, setApplyingFilters] = useState(false);
  const [filtersPinned, setFiltersPinned] = useState(
    () => localStorage.getItem("staffs_filters_pinned") === "true"
  );

  const defaultGridHeader = [
    {
      title: "Name",
      name: "name",
      type: "text",
      filter: false,
    },
    {
      title: "Last Name",
      name: "last_name",
      type: "text",
      filter: false,
    },
    {
      title: "Group Member",
      name: "employee_type",
      type: "text",
      filter: true,
    },
    {
      title: "Employee",
      name: "employee_subtype",
      type: "text",
      filter: true,
    },
  ];
  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find((el) => el.alias === "staffs");

  const mapStaffs = (data) =>
    data.map(
      (
        { id, name, last_name, employee_type, employee_subtype, canceled_at },
        index
      ) => {
        const ret = {
          show: true,
          id,
          fields: [name, last_name, employee_type, employee_subtype],
          canceled: canceled_at,
          page: Math.ceil((index + 1) / limit),
        };
        return ret;
      }
    );

  async function loader() {
    setLoadingData(true);
    const stored = getStoredFilters();
    const extraParams = {};
    if (stored) {
      if (stored.employeeType) extraParams.type = stored.employeeType;
      if (stored.employeeSubtype) extraParams.subtype = stored.employeeSubtype;
      if (stored.isStudent) extraParams.is_student = stored.isStudent;
      if (stored.isUsCitizen) extraParams.is_us_citizen = stored.isUsCitizen;
      if (stored.departmentId) extraParams.department_id = stored.departmentId;
      if (stored.jobDescriptionId) extraParams.jobdescription_id = stored.jobDescriptionId;
      if (stored.startDateFrom) extraParams.admission_date_from = stored.startDateFrom;
      if (stored.startDateTo) extraParams.admission_date_to = stored.startDateTo;
      if (stored.resignationDateFrom) extraParams.resignation_date_from = stored.resignationDateFrom;
      if (stored.resignationDateTo) extraParams.resignation_date_to = stored.resignationDateTo;
    }
    const data = await getData("staffs", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
      extraParams: Object.keys(extraParams).length ? extraParams : null,
    });

    if (!data) {
      return;
    }
    setGridData(mapStaffs(data));
    setLoadingData(false);
  }

  const applyFiltersToGrid = async (queryString) => {
    setApplyingFilters(true);
    setLoadingData(true);
    try {
      const { data } = await api.get(queryString);
      console.log("Filtered staffs response:", data);
      const pagesCalc = Math.ceil((data?.totalRows || 0) / limit) || 1;
      setPages(pagesCalc);
      setGridDetails({
        totalRows: data?.totalRows || 0,
        pages: pagesCalc,
      });
      setGridData(mapStaffs(data?.rows || []));
    } catch (err) {
      console.log(err);
    } finally {
      setApplyingFilters(false);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page]);

  return (
    <>
      <ModalFilters
        opened={filtersModalOpen}
        applying={applyingFilters}
        onClose={() => {
          setFiltersModalOpen(false);
          setFiltersPinned(
            localStorage.getItem("staffs_filters_pinned") === "true"
          );
        }}
        onApplyFilters={applyFiltersToGrid}
      />
      <PageContainer
        FullGridContext={FullGridContext}
        PagePreview={PagePreview}
        pageAccess={pageAccess}
        defaultGridHeader={defaultGridHeader}
        filtersModal={{
          onOpen: () => setFiltersModalOpen(true),
          viewSelect: filtersPinned ? (
            <div className="flex items-center gap-1 text-orange-500 text-xs font-medium">
              <Pin size={13} className="fill-orange-500" />
              Filters Applied
            </div>
          ) : null,
        }}
      />
    </>
  );
}
